import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@wapharma/design-system/tokens.css';
import '@hamssah/design-system/tokens.css';
import '@hamssah/design-system/typography.css';
import '@hamssah/design-system/breakpoints.css';
import './styles/brand-logo.css';
import './styles/a11y.css';
import './fonts';
import '@wapharma/design-system/scrollbar.css';
import { App } from './App';
import { initAdminSentry } from './lib/sentry';
import { AppErrorBoundary } from './components/AppErrorBoundary';

initAdminSentry();

function Root() {
  return (
    <>
      <AppErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppErrorBoundary>
    </>
  );
}

const app = <Root />;

/** StrictMode double-mounts huge pages (Catalog) and wedges dev tab on nav. */
ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.PROD ? <StrictMode>{app}</StrictMode> : app,
);
